import { MenuNavHandlers } from "./MenuNavHandlers";

const MENU_NAV_CTAS_SELECTOR = '.main-nav__ctas-menu-nav';

export class MenuDesktopNav extends MenuNavHandlers {

  constructor(domNode, isMegaNav) {
    super();

    this.isMegaNav = isMegaNav;
    if(domNode.classList.contains(MENU_NAV_CTAS_SELECTOR)) {
      this.domNode = domNode;
    } else {
      this.domNode = domNode.querySelector(MENU_NAV_CTAS_SELECTOR);
    }

    if (!domNode) {
        return;
    }

    Array.from(domNode.querySelectorAll('a[aria-haspopup=true]')).forEach((item) => {
      this.addListener(item, "click", this.onMenuitemClick.bind(this), { capture: true });
    });
    this.addListener(window, "pointerdown", this.onBackgroundPointerdown.bind(this), true);
    this.closePopupAll();
  }

  closePopupAll(menuitem) {

    // close all siblinblings from same ul group
    if(menuitem) {
      const result = [];
      const liItem = menuitem.parentNode;
      const ulGroup = liItem.parentNode;
      let node = ulGroup.firstChild;

      while (node) {
        if (node !== menuitem && node.nodeType === Node.ELEMENT_NODE) {
          result.push(node);
        }
        node = node.nextElementSibling || node.nextSibling;
      }
      result.forEach((itemLi) => {
        const aElem = itemLi.querySelector(':scope > a[aria-haspopup=true]');
        if (aElem) {
          aElem.setAttribute("aria-expanded", "false");
        };
      })

    // close all popups
    } else {
      Array.from(this.domNode.querySelectorAll('a[aria-haspopup=true]')).forEach((item) => {
        item.setAttribute("aria-expanded", "false");
      });
    }

  }

  closePopup(menuitem) {
    if(menuitem && menuitem.setAttribute) {
        menuitem.setAttribute("aria-expanded", "false");
    }
  }

  openPopup(menuitem) {

    if(!menuitem) return false;

    menuitem.setAttribute("aria-expanded", "true");

    const liItem = menuitem.parentNode;
    const ulGroup = liItem.parentNode;
    if(ulGroup.getAttribute('role') === 'menubar') {

      const popupMenuContainer = menuitem.nextElementSibling;
      const allSubMenuItems = popupMenuContainer.querySelectorAll(
        this.isMegaNav ? ':scope > ul > li > a' : ':scope > li > a'
        );
      Array.from(allSubMenuItems).forEach(submenuitem => {
        // close all submenues when open a menu
        if (submenuitem && submenuitem.setAttribute) {
          submenuitem.setAttribute("aria-expanded", "false");
        }
      });
      
      if (this.isMegaNav) {
        const firstMenuItem = popupMenuContainer.querySelector(':scope > ul > li > a');
        if (firstMenuItem && firstMenuItem.setAttribute) {
          firstMenuItem.setAttribute("aria-expanded", "true");
        }
      }
    }

    return false;
  }

}
